import { useReactiveVar } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { Meta, theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import { Container } from 'components/park/styles/styles';
import HslContext from 'context/HslContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native-gesture-handler';
import { country } from 'states/persistInStorage';
import { useHslStore } from 'stores/hslStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { HslTicketPricing } from 'types/generatedSchemaTypes';
import { HslParkingStackParamList, ServicesNavProps } from 'types/navigation';
import { currencyFormatter } from 'utils/commonUtils';

const HslDurationSelection = () => {
  const { hslPricingResult } = useContext(HslContext);

  const { t } = useTranslation();
  const countryCode = useReactiveVar(country);
  const data = hslPricingResult?.data?.readHslTicketPricing;
  const { navigate } = useNavigation<ServicesNavProps>();
  const { goBack, canGoBack } =
    useNavigation<StackNavigationProp<HslParkingStackParamList>>();

  const handleBack = () => {
    if (canGoBack()) {
      goBack();
    } else {
      navigate('hslNavigator', { screen: 'hslTicket' });
    }
  };
  const selectValue = (pricing: HslTicketPricing) => {
    useHslStore.getState().setSelectedHslPricing(pricing);
    handleBack();
  };

  return (
    <Container testID="hsl-select-duration-ticket-container" mr={20} ml={20}>
      <ScrollView>
        {data?.map((pricing) => (
          <StyledWrapper key={`hsl-duration-${pricing?.validityPeriod}`} mb={5}>
            <MenuItem
              noBorder
              testID={`hsl-duration-item-${pricing?.validityPeriod}`}
              onPress={() => selectValue(pricing as HslTicketPricing)}
              menuLabel={t('hslTicket.validity.days', {
                value: pricing?.validityPeriod,
              })}
              rightComponent={
                <Meta color={theme.colors.gray300}>
                  {currencyFormatter(
                    (pricing?.currentPrice as number) / 100,
                    countryCode,
                    true
                  )}
                </Meta>
              }
              background={theme.colors.gray50}
            />
          </StyledWrapper>
        ))}
      </ScrollView>
    </Container>
  );
};

export default HslDurationSelection;
